import { createNumberMask } from "text-mask-addons";
import { Vue, Component } from "vue-property-decorator";
import { i18n } from "../i18n";
import NumberUtils from "../input/NumberUtils";

@Component
export default class NumericMixin extends Vue {

    numericAbcMask(decimals = -1, locale = i18n.locale) {
        const [thousandSep, decimalSep] = NumberUtils.computeSeperators(locale);
        const mask = createNumberMask({
            prefix: "",
            allowDecimal: decimals != 0,
            decimalLimit: NumberUtils.maxDecimals(decimals),
            decimalSymbol: decimalSep,
            thousandsSeparatorSymbol: thousandSep,
            integerLimit: null,
            requireDecimal: false,
            allowNegative: true,
            allowLeadingZeroes: false,
        });
        return mask;
    }
}   